"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _TextInput = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextInput");

var _TextInput2 = _interopRequireDefault(_TextInput);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookieNotice = (0, _glamor.css)({
  position: "fixed",
  fontSize: (0, _css.unitRem)(0.625),
  borderRadius: 5,
  width: "100%",
  // height: unitRem(7.91),

  padding: "1.87rem 1.5625rem",

  bottom: (0, _css.unitRem)(1),
  right: 0,
  left: 0,

  lineHeight: 1.5,
  textAlign: "center",

  color: _css.pallets.gray_text,
  background: _css.pallets.grayMidLight_dropDowns,

  zIndex: 50,

  boxShadow: "0 0 50px rgba(0,0,0,1)"
}, (0, _css.minWidth)(_css.breakpoints.small)({
  width: (0, _css.unitRem)(16.6666666667),
  padding: (0, _css.unitRem)(1.1) + " " + (0, _css.unitRem)(1.75),

  bottom: (0, _css.unitRem)(1),
  right: (0, _css.unitRem)(1),
  left: "unset",

  boxShadow: "0 0 50px rgba(0,0,0,1)"
}));

var textButton = (0, _glamor.css)({
  padding: 0
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    smallLarge: 1
  }
}));

var inner = (0, _glamor.css)(_fonts.p4, {
  display: "block",
  textAlign: "left"
});

var okButton = (0, _glamor.css)(_fonts.textBtn2, {
  "& button": {
    paddingLeft: (0, _css.unitRem)(1.95),
    paddingRight: (0, _css.unitRem)(1.95),
    width: "100%"
  }
});

var header = (0, _glamor.css)(_fonts.subH3, {
  textTransform: "uppercase",
  fontFamily: "Open Sans Condensed",
  color: _css.pallets.white,
  marginBottom: (0, _css.unitRem)(0.7)
});
var close = function close(showWhite) {
  return (0, _glamor.css)(_css.btnReset, {
    position: "absolute",
    top: "1.3vw",
    right: "1.4vw",
    zIndex: 1,
    width: (0, _css.unitRem)(1),
    height: (0, _css.unitRem)(1),

    cursor: "pointer",
    transition: "color " + _css.time.fast + " linear",
    color: showWhite ? "#fff" : "#535353",
    fontSize: "23px",

    ":hover": {
      //transform: 'scale(1.1, 1.1)',
      color: showWhite ? "#aaa" : "#eee"
    },
    ":after": {
      content: '"✕"',
      width: "100%",
      textShadow: "0 0 2px rgba(0,0,0,0.5)"
    }
  }, (0, _css.maxWidth)(_css.breakpoints.medium)({
    left: "calc(100vw - 42px)"
  }), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
    right: "2.50vw"
  }), (0, _css.minWidth)(_css.breakpoints.xxlarge)({
    top: "1vw",
    right: "1.4vw"
  }));
};

var SubscribedNotice = function (_React$Component) {
  (0, _inherits3.default)(SubscribedNotice, _React$Component);

  function SubscribedNotice(props) {
    (0, _classCallCheck3.default)(this, SubscribedNotice);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SubscribedNotice.__proto__ || (0, _getPrototypeOf2.default)(SubscribedNotice)).call(this, props));

    _this.state = {
      subscriberEmail: ""
    };
    _this.onChangeHandler = _this.onChangeHandler.bind(_this);
    _this.validateEmail = _this.validateEmail.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SubscribedNotice, [{
    key: "onChangeHandler",
    value: function onChangeHandler(ev) {
      this.setState({
        subscriberEmail: ev.target.value
      });
    }
  }, {
    key: "validateEmail",
    value: function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      return _react2.default.createElement(
        "div",
        { className: cookieNotice },
        _react2.default.createElement("button", { className: close(), onClick: function onClick() {
            return props.onDiscard();
          } }),
        _react2.default.createElement(
          "form",
          null,
          _react2.default.createElement(
            "div",
            { className: inner },
            _react2.default.createElement(
              "h1",
              { className: header },
              "Be the first to know"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Don\u2019t miss out on exciting offers, new products, and useful tutorials. No spam, just the good stuff!"
            ),
            _react2.default.createElement(_TextInput2.default, {
              onChange: this.onChangeHandler,
              value: this.state.subscriberEmail,
              className: (0, _glamor.css)(_fonts.p4, { marginTop: (0, _css.unitRem)(1) }),
              placeholder: "hello@domain.com",
              name: "EMAIL",
              type: "email"
            })
          ),
          _react2.default.createElement(
            "div",
            { className: (0, _glamor.css)({ marginTop: (0, _css.unitRem)(1), width: "100%" }) },
            _react2.default.createElement(_Button2.default, {
              className: okButton,
              label: "SUBSCRIBE TO NEWSLETTER",
              mode: "secondary",
              type: "button",
              small: true,
              onClick: function onClick() {
                var email = _this2.state.subscriberEmail;
                var validateEmail = _this2.validateEmail;
                setTimeout(function () {
                  if (validateEmail(email)) {
                    props.onClickHandler(email);
                    props.onDiscard(true);
                  }
                }, 1000);
              }
            })
          )
        )
      );
    }
  }]);
  return SubscribedNotice;
}(_react2.default.Component);

exports.default = SubscribedNotice;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SubscribedNotice/index.js
// module id = 2670
// module chunks = 0